import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=0b955bd9&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b955bd9",
  null
  
)

export default component.exports